import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { Popover } from "@mui/material";
import React, { useState, useEffect } from "react";

function PTMIconPicker(props) {
    const { icon, setIcon, defaultIcon } = props;

    const icons = Object.keys(fas).map((item) => fas[item].iconName);

    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [iconNotAvailable, setIconNotAvailable] = useState(false);

    useEffect(() => {
        if (icon === "" || !icons.includes(icon)) {
            setIconNotAvailable(true);
        } else {
            setIconNotAvailable(false);
        }
    }, [icon]);

    const handlePopoverOpen = (e) => {
        setPopoverAnchor(e.currentTarget);
    };

    const handlePopoverClose = () => {
        setPopoverAnchor(null);
    };

    const selectIcon = (selectedIcon) => {
        setIcon(selectedIcon);
        setPopoverAnchor(null);
    };

    return (
        <>
            <FontAwesomeIcon
                icon={iconNotAvailable ? defaultIcon : icon}
                onClick={handlePopoverOpen}
                title="Icon auswählen"
            />
            {popoverAnchor ? (
                <Popover
                    id="mouse-over-popover"
                    open={!!popoverAnchor}
                    anchorEl={popoverAnchor}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "left",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left",
                    }}
                    onClose={handlePopoverClose}
                >
                    <div
                        style={{
                            overflow: "auto",
                            height: "calc(100% - 30px)",
                            padding: 2,
                        }}
                    >
                        <div
                            className="icon-picker-grid"
                            style={{
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr));",
                                width: 95,
                                height: 200,
                            }}
                        >
                            <div className="icon-picker-grid-item">
                                {icons.map((item) => (
                                    <FontAwesomeIcon
                                        key={item}
                                        icon={item}
                                        style={{ margin: 2, fontSize: 15, cursor: "pointer" }}
                                        fixedWidth
                                        onClick={() => selectIcon(item)}
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </Popover>
            ) : null}
        </>
    );
}

export default PTMIconPicker;
